export enum IntegrationCodeEnum {
  MAPOS_MASTORE = "MAPOS-MASTORE",
  LYPRO_MAPOS_NOTIFICATIONS_BOT = "LYPRO-MAPOS-NOTIFICATIONS-BOT",
  LYPRO_TRAVEL = "LYPRO-TRAVEL",
  LYPRO_CARS = "LYPRO-CARS",
  LYPRO_STAYS = "LYPRO-STAYS",
  LYPRO_TEST = "LYPRO-TEST",
  BANCHAT = "BANCHAT",
  INVOICES = "INVOICES",
  LYPRO_ADMIN = "LYPRO-ADMIN",
}

export enum IntegrationPermissionEnum {
  Analytics = "analytics",
  Chats = "chats",
  ApiSettings = "api_settings",
  Travel = "travel",
  CarRental = "car_rental",
  Stays = "stays",
  TestChat = "test_chat",
  Invoices = "invoices",
  Billing = "billing",
  LyproAdmin = "lypro_admin",
}

const INTEGRATION_PERMISSIONS: Record<string, IntegrationPermissionEnum[]> = {
  [IntegrationCodeEnum.MAPOS_MASTORE]: [
    IntegrationPermissionEnum.Analytics,
    IntegrationPermissionEnum.Chats,
    IntegrationPermissionEnum.ApiSettings,
    IntegrationPermissionEnum.Billing,
  ],
  [IntegrationCodeEnum.LYPRO_MAPOS_NOTIFICATIONS_BOT]: [
    IntegrationPermissionEnum.Chats,
    IntegrationPermissionEnum.ApiSettings,
  ],
  [IntegrationCodeEnum.LYPRO_TRAVEL]: [
    IntegrationPermissionEnum.Analytics,
    IntegrationPermissionEnum.Chats,
    IntegrationPermissionEnum.ApiSettings,
    IntegrationPermissionEnum.Travel,
    IntegrationPermissionEnum.Billing,
  ],
  [IntegrationCodeEnum.LYPRO_CARS]: [
    IntegrationPermissionEnum.Analytics,
    IntegrationPermissionEnum.Chats,
    IntegrationPermissionEnum.ApiSettings,
    IntegrationPermissionEnum.CarRental,
    IntegrationPermissionEnum.Billing,
  ],
  [IntegrationCodeEnum.LYPRO_STAYS]: [
    IntegrationPermissionEnum.Analytics,
    IntegrationPermissionEnum.Chats,
    IntegrationPermissionEnum.ApiSettings,
    IntegrationPermissionEnum.Stays,
    IntegrationPermissionEnum.Billing,
  ],
  [IntegrationCodeEnum.LYPRO_TEST]: [IntegrationPermissionEnum.TestChat],
  [IntegrationCodeEnum.BANCHAT]: [
    IntegrationPermissionEnum.Chats,
    IntegrationPermissionEnum.ApiSettings,
  ],
  [IntegrationCodeEnum.INVOICES]: [
    IntegrationPermissionEnum.Invoices,
    IntegrationPermissionEnum.Billing,
  ],
  [IntegrationCodeEnum.LYPRO_ADMIN]: [IntegrationPermissionEnum.LyproAdmin],
};

export const ROUTE_PERMISSIONS: Record<string, IntegrationPermissionEnum> = {
  "/dashboard": IntegrationPermissionEnum.Analytics,
  "/dashboard/conversations": IntegrationPermissionEnum.Analytics,
  "/dashboard/chats": IntegrationPermissionEnum.Chats,
  "/dashboard/settings": IntegrationPermissionEnum.ApiSettings,
  "/dashboard/travel": IntegrationPermissionEnum.Travel,
  "/dashboard/travel/settings": IntegrationPermissionEnum.Travel,
  "/dashboard/travel/design": IntegrationPermissionEnum.Travel,
  "/dashboard/travel/pages": IntegrationPermissionEnum.Travel,
  "/dashboard/travel/seo": IntegrationPermissionEnum.Travel,
  "/dashboard/travel/locations": IntegrationPermissionEnum.Travel,
  "/dashboard/travel/services": IntegrationPermissionEnum.Travel,
  "/dashboard/travel/packages": IntegrationPermissionEnum.Travel,
  "/dashboard/travel/domains": IntegrationPermissionEnum.Travel,
  "/dashboard/travel/bookings": IntegrationPermissionEnum.Travel,
  "/dashboard/car-rental": IntegrationPermissionEnum.CarRental,
  "/dashboard/car-rental/settings": IntegrationPermissionEnum.CarRental,
  "/dashboard/car-rental/design": IntegrationPermissionEnum.CarRental,
  "/dashboard/car-rental/pages": IntegrationPermissionEnum.CarRental,
  "/dashboard/car-rental/seo": IntegrationPermissionEnum.CarRental,
  "/dashboard/car-rental/fleet": IntegrationPermissionEnum.CarRental,
  "/dashboard/car-rental/domains": IntegrationPermissionEnum.CarRental,
  "/dashboard/car-rental/reservations": IntegrationPermissionEnum.CarRental,
  "/dashboard/stays": IntegrationPermissionEnum.Stays,
  "/dashboard/stays/settings": IntegrationPermissionEnum.Stays,
  "/dashboard/stays/design": IntegrationPermissionEnum.Stays,
  "/dashboard/stays/pages": IntegrationPermissionEnum.Stays,
  "/dashboard/stays/seo": IntegrationPermissionEnum.Stays,
  "/dashboard/stays/properties": IntegrationPermissionEnum.Stays,
  "/dashboard/stays/domains": IntegrationPermissionEnum.Stays,
  "/dashboard/stays/reservations": IntegrationPermissionEnum.Stays,
  "/dashboard/test-chat": IntegrationPermissionEnum.TestChat,
  "/dashboard/invoices/analytics": IntegrationPermissionEnum.Invoices,
  "/dashboard/invoices/categories": IntegrationPermissionEnum.Invoices,
  "/dashboard/invoices/items": IntegrationPermissionEnum.Invoices,
  "/dashboard/invoices/customers": IntegrationPermissionEnum.Invoices,
  "/dashboard/invoices/sellers": IntegrationPermissionEnum.Invoices,
  "/dashboard/invoices/reminders": IntegrationPermissionEnum.Invoices,
  "/dashboard/invoices/quotes": IntegrationPermissionEnum.Invoices,
  "/dashboard/invoices/quote-history": IntegrationPermissionEnum.Invoices,
  "/dashboard/invoices/new-sale": IntegrationPermissionEnum.Invoices,
  "/dashboard/invoices/sales": IntegrationPermissionEnum.Invoices,
  "/dashboard/billing": IntegrationPermissionEnum.Billing,
  "/dashboard/admin": IntegrationPermissionEnum.LyproAdmin,
};

const ROUTE_PRIORITY = [
  "/dashboard",
  "/dashboard/conversations",
  "/dashboard/chats",
  "/dashboard/settings",
  "/dashboard/travel",
  "/dashboard/travel/settings",
  "/dashboard/travel/design",
  "/dashboard/travel/pages",
  "/dashboard/travel/seo",
  "/dashboard/travel/locations",
  "/dashboard/travel/services",
  "/dashboard/travel/packages",
  "/dashboard/travel/domains",
  "/dashboard/travel/bookings",
  "/dashboard/car-rental",
  "/dashboard/car-rental/settings",
  "/dashboard/car-rental/design",
  "/dashboard/car-rental/pages",
  "/dashboard/car-rental/seo",
  "/dashboard/car-rental/fleet",
  "/dashboard/car-rental/domains",
  "/dashboard/car-rental/reservations",
  "/dashboard/stays",
  "/dashboard/stays/settings",
  "/dashboard/stays/design",
  "/dashboard/stays/pages",
  "/dashboard/stays/seo",
  "/dashboard/stays/properties",
  "/dashboard/stays/domains",
  "/dashboard/stays/reservations",
  "/dashboard/test-chat",
  "/dashboard/invoices/analytics",
  "/dashboard/invoices/categories",
  "/dashboard/invoices/items",
  "/dashboard/invoices/customers",
  "/dashboard/invoices/sellers",
  "/dashboard/invoices/reminders",
  "/dashboard/invoices/quotes",
  "/dashboard/invoices/quote-history",
  "/dashboard/invoices/new-sale",
  "/dashboard/invoices/sales",
  "/dashboard/billing",
  "/dashboard/admin",
];

const COMPANY_ADMIN_PATHS = new Set(["/dashboard/billing"]);

const normalizePath = (path: string) => path.replace(/\/$/, "") || "/";

export const normalizeIntegrations = (integrations?: string[]) =>
  Array.isArray(integrations)
    ? integrations
        .map((integration) => integration?.trim())
        .filter((integration): integration is string => Boolean(integration))
    : [];

export const getGrantedPermissions = (
  integrations?: string[]
): IntegrationPermissionEnum[] => {
  const grantedPermissions = new Set<IntegrationPermissionEnum>();

  normalizeIntegrations(integrations).forEach((integration) => {
    (INTEGRATION_PERMISSIONS[integration] || []).forEach((permission) =>
      grantedPermissions.add(permission)
    );
  });

  return Array.from(grantedPermissions);
};

export const hasPermission = (
  integrations: string[] | undefined,
  permission: IntegrationPermissionEnum
) => getGrantedPermissions(integrations).includes(permission);

export const getPermittedPaths = (integrations?: string[]) =>
  ROUTE_PRIORITY.filter((path) =>
    COMPANY_ADMIN_PATHS.has(path) ||
    hasPermission(integrations, ROUTE_PERMISSIONS[path])
  );

export const canAccessPath = (integrations: string[] | undefined, path: string) => {
  const normalizedPath = normalizePath(path);

  if (normalizedPath === "/dashboard/no-access") {
    return true;
  }

  const requiredPermission = ROUTE_PERMISSIONS[normalizedPath];
  if (!requiredPermission) {
    return false;
  }

  if (COMPANY_ADMIN_PATHS.has(normalizedPath)) {
    return true;
  }

  return hasPermission(integrations, requiredPermission);
};

export const getDefaultAuthorizedPath = (integrations?: string[]) =>
  getPermittedPaths(integrations)[0] || null;
